import { useState } from 'react';
import { Menu, type MenuEntry } from '../../ui/menu';

/** A context menu anchored to the press, kept inside the viewport by the shared menu. */
export function QuickMenu({ at, items, onClose, label = 'Canvas actions' }: {
  at: { x: number; y: number } | null;
  items: readonly MenuEntry[];
  onClose: () => void;
  label?: string;
}) {
  const [anchor, setAnchor] = useState<HTMLSpanElement | null>(null);
  if (!at) return null;
  return <>
    <span ref={setAnchor} aria-hidden className="pointer-events-none fixed" style={{ left: at.x, top: at.y, width: 0, height: 0 }} />
    <Menu key={`${at.x}:${at.y}`} open anchor={anchor} onClose={onClose} items={items} width={216} variant="context" label={label} />
  </>;
}
